// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2efb21de]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.ant-result-404[data-v-2efb21de] {\n  padding-top: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
